/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroupAssignmentUserUserType
 */
export interface UserGroupAssignmentUserUserType {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    title?: string;
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    description?: string;
}

/**
 * Check if a given object implements the UserGroupAssignmentUserUserType interface.
 */
export function instanceOfUserGroupAssignmentUserUserType(value: object): value is UserGroupAssignmentUserUserType {
    return true;
}

export function UserGroupAssignmentUserUserTypeFromJSON(json: any): UserGroupAssignmentUserUserType {
    return UserGroupAssignmentUserUserTypeFromJSONTyped(json, false);
}

export function UserGroupAssignmentUserUserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupAssignmentUserUserType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'type': json['type'] == null ? undefined : json['type'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function UserGroupAssignmentUserUserTypeToJSON(json: any): UserGroupAssignmentUserUserType {
    return UserGroupAssignmentUserUserTypeToJSONTyped(json, false);
}

export function UserGroupAssignmentUserUserTypeToJSONTyped(value?: UserGroupAssignmentUserUserType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'type': value['type'],
        'description': value['description'],
    };
}

